import toast from 'react-hot-toast';
import { createRoot } from 'react-dom/client';
import ConfirmDialog from '@/components/ConfirmDialog/ConfirmDialog';
import { info } from './message';
import * as trackingPoint from './trackingPoint';

export default {
  toastMsg(title, style) {
    info(title);
  },
  reportData(event, data) {
    trackingPoint.reportData(event, data || {});
  },
  confirm({
    message,
    cancelText = 'Cancel',
    confirmText = 'Confirm',
    cancelFunction,
    confirmFunction,
  }) {
    // 1. 创建容器
    const container = document.createElement('div');
    container.className = 'confirm-pop';
    document.body.appendChild(container);

    // 2. 创建 root
    const root = createRoot(container);

    // 3. 关闭方法
    const close = () => {
      root.unmount();
      document.body.removeChild(container);
    };

    console.log('ConfirmDialog', ConfirmDialog);

    // 4. 渲染组件
    root.render(
      <ConfirmDialog
        confirmTitle={confirmText}
        content={message}
        cancelText={cancelText}
        onConfirm={() => {
          confirmFunction?.();
          close();
        }}
        onCancel={() => {
          cancelFunction?.();
          close();
        }}
      />,
    );
  },
};
